module.exports={render:function (){with(this) {
  return _h('tr', [_h('td', {
    staticClass: "number"
  }, [_h('button', {
    on: {
      "click": removeProduct
    }
  }, ["Usuń"]), "\n    " + _s(positionNumber) + ".\n  "]), " ", _h('td', [_h('editable', {
    attrs: {
      "block": "",
      "id": ("name-" + _uid)
    },
    domProps: {
      "value": name
    },
    on: {
      "change": function($event) {
        name = $event
      }
    }
  })]), " ", _h('td', {
    staticClass: "number"
  }, [_h('editable', {
    attrs: {
      "number": "",
      "id": ("quantity-" + _uid)
    },
    domProps: {
      "value": quantity
    },
    on: {
      "change": function($event) {
        quantity = $event
      }
    }
  })]), " ", _h('td', [_h('editable', {
    attrs: {
      "id": ("quantityType-" + _uid)
    },
    domProps: {
      "value": quantityType
    },
    on: {
      "change": function($event) {
        quantityType = $event
      }
    }
  })]), " ", _h('td', {
    staticClass: "number"
  }, [_h('editable', {
    attrs: {
      "money": "",
      "id": ("priceNetto-" + _uid)
    },
    domProps: {
      "value": priceNetto
    },
    on: {
      "change": function($event) {
        priceNetto = $event
      }
    }
  })]), " ", _h('td', {
    staticClass: "number"
  }, [_h('editable', {
    attrs: {
      "number": "",
      "id": ("vat-" + _uid)
    },
    domProps: {
      "value": vat
    },
    on: {
      "change": function($event) {
        vat = $event
      }
    }
  })]), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(nettoValue))]), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(vatValue))]), " ", _h('td', {
    staticClass: "number"
  }, [_s(money(bruttoValue))])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/InvoiceRow.vue
 ** module id = 174
 ** module chunks = 2
 **/